import { render, staticRenderFns } from "./add.vue?vue&type=template&id=01d43a0b"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d43a0b')) {
      api.createRecord('01d43a0b', component.options)
    } else {
      api.reload('01d43a0b', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=01d43a0b", function () {
      api.rerender('01d43a0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/csg/add.vue"
export default component.exports